export default __webpack_public_path__ + "static/media/060_corner2_02.2668327a.mp3";